<div class="flex flex-col md:flex-row gap-6 justify-center items-center p-6 sm:px-12 lg:px-27 m-auto">
    <div class="flex flex-col gap-4 text-text-primary bg-white rounded-2xl shadow-xl p-4 w-80 sm:w-98">
        <img src="assets/images/truck.webp" alt="ride"/>        
        <div class="flex flex-col gap-1">
            <div class="h3-text" i18n>Create a ride</div>
            <div class="body-xs-text" i18n>For drivers</div>
        </div>
        <div class="body-s-text" i18n>You have free space in your vehicle? Set your route, date, and available spots for horse owners and save money.</div>
        <button class="primary-button" routerLink="/ride/create" i18n>Create a ride</button>
    </div>

    <div class="flex flex-col gap-4 text-text-primary bg-white rounded-2xl shadow-xl p-4 w-80 sm:w-98">
        <img src="assets/images/horse.webp" alt="ride request"/>
        <div class="flex flex-col gap-1">
            <div class="h3-text" i18n>Create a ride request</div>
            <div class="body-xs-text" i18n>For horse owners</div>
        </div>
        <div class="body-s-text" i18n>Need transportation for your horse? Create a request with your details, and drivers will send you offers.</div>
        <button class="primary-button" routerLink="/ride-request/create" i18n>Create a ride request</button>
    </div>
</div>